export const APP_PATHS = {
  activateAccount: '/invite/register',
  activateAccountError: '/invite/register/error',
  alreadyRegistered: '/invite/registered',
  confirm: '/invite/register/confirmation',
  enterZipCode: '/invite/enter',
  enterZipCodeError: '/invite/enter/error',
  inviteExpired: '/invite/expire',
  termsConditions: '/invite/register/terms-conditions',
};

export const COMCAST_BUSINESS_PATHS = {
  account: 'https://business.comcast.com/account/',
  forgotEmail:
    'https://business.comcast.com/myaccount/Registration/ForgotEmail',
  forgotPassword:
    'https://business.comcast.com/myaccount/Registration/ForgotPassword',
  home: 'https://business.comcast.com/',
};
